export const iconButton = {
  MuiIconButton: {
    root: {
      padding: "0",
    },
  },
};
